/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetNewsletterDto
 */
export interface SetNewsletterDto {
    /**
     * 
     * @type {boolean}
     * @memberof SetNewsletterDto
     */
    newsletter: boolean;
}

export function SetNewsletterDtoFromJSON(json: any): SetNewsletterDto {
    return SetNewsletterDtoFromJSONTyped(json, false);
}

export function SetNewsletterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetNewsletterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newsletter': json['newsletter'],
    };
}

export function SetNewsletterDtoToJSON(value?: SetNewsletterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newsletter': value.newsletter,
    };
}

